import { isDevMode } from '@angular/core';

export const IS_LOCAL_BACKEND = false;

const BACKEND_URLS = {
  development: 'https://api-senet-id.ensedev.com/api/v1/',
  production: 'https://api-senet-id.enes.tech/api/v1/',
  local: 'http://localhost:8001/api/v1/',
};

const DOMAINS = {
  development: 'senet-id.ensedev.com',
  production: 'senet.id',
};

export const isProduction = window.location.hostname === DOMAINS.production;

export const getBackendUrl = () => {
  // ? Якщо увімкнено локальний бекенд в dev mode
  if (isDevMode() && IS_LOCAL_BACKEND) {
    return BACKEND_URLS.local;
  }

  const hostname = window.location.hostname;

  // ? Продакшн
  if (hostname === DOMAINS.production) {
    return BACKEND_URLS.production;
  }

  // ? Девелопмент
  if (hostname === DOMAINS.development) {
    return BACKEND_URLS.development;
  }

  // ? Локальна розробка або інші випадки - дев бекенд за замовчуванням
  return BACKEND_URLS.development;
};
